import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Input, Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container, i18n } from '../../../../symphony';

import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';

import s from './QuestionsSearch.scss';

export function QuestionsSearch() {
	useStyles(s);
	const [searchParams, setSearchParams] = useSearchParams();

	const [searchedInputValue, setSearchedInputValue] = useState(
		searchParams.get('query') || '',
	);

	const searchSubmitHandler: React.FormEventHandler<HTMLFormElement> = (
		event,
	) => {
		event.preventDefault();
		const { actions$ } = Container.take(SlDiscussContext, SlActions);

		searchParams.set('query', searchedInputValue);
		searchParams.set('page', '1');
		setSearchParams(searchParams);
		actions$.next({
			type: ActionType.OnSearchClick,
			requestType: RequestType.Parallel,
			data: {
				searchedInputValue,
			},
		});
	};

	return (
		<form
			onSubmit={searchSubmitHandler}
			className="discuss-questions-search"
		>
			<Input
				size="m"
				type="search"
				className="discuss-questions-search__input"
				placeholder={i18n.t('web-discuss.search-placeholder')}
				value={searchedInputValue}
				onChange={(e) => {
					setSearchedInputValue(e.target.value);
				}}
			/>
			<Input
				size="s"
				type="search"
				className="discuss-questions-search__input__small"
				placeholder={i18n.t('web-discuss.search-placeholder')}
				value={searchedInputValue}
				onChange={(e) => {
					setSearchedInputValue(e.target.value);
				}}
			/>
			<Button
				className="discuss-questions-search__search"
				size="m"
				buttonType="secondary"
				type="submit"
			>
				{i18n.t('web-discuss.search-button')}
			</Button>
			<Button
				className="discuss-questions-search__search__small"
				size="s"
				buttonType="secondary"
				type="submit"
			>
				{i18n.t('web-discuss.search-button')}
			</Button>
		</form>
	);
}
